import React from 'react';
import { IconProps } from '../../../lib/types';

const Triangle: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29 33"
      className={className}
    >
      <path d="M29 16.5L0 33V0z" className="a"></path>
    </svg>
  );
};

export default Triangle;
